import {observer} from 'mobx-react';
import {withState, t} from 'shared/core';
import {Display, Panel, LabelHelper} from 'shared/components';
import AnnotatablePdfPreview from 'main/components/pdf/annotate/components/AnnotatablePdfPreview';
import TaxFormTemplateEditState from '../state/TaxFormTemplateEditState';

const TaxFormTemplateEditor = observer(({uiState}) => {
  const {taxFormTemplate, companyDocument, errors, pdfUrl} = uiState;

  return (
    <div>
      <Display
        title={`${taxFormTemplate.templateType} (${taxFormTemplate.locale}) ${taxFormTemplate.year}`}
        onBackClick={() => uiState.backToIndex()}
      />
      <div className='Container pb4'>
        <Panel>
          <LabelHelper label={t('tax_form_templates.Tax Form Template Fields')}/>
          <AnnotatablePdfPreview
            companyDocument={companyDocument}
            errors={errors}
            pdfUrl={pdfUrl}
            includeTaxFields
            hideAssigneeSelector
            onSave={annotations => uiState.saveAnnotations(annotations)}
            onCancel={() => uiState.backToIndex()}
          />
        </Panel>
      </div>
    </div>
  );
});

export default withState(TaxFormTemplateEditor, TaxFormTemplateEditState);
